




































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import ScrollView from '@/components/ScrollView.vue'
import { MONTHS } from '@/constants'
import { BatchModule } from '@/store/modules/batch.module'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: { Modal, ScrollView },
  props: {
    isReview: {
      type: Boolean,
      default: false
    },
    batchId: {
      type: Number
    }
  }
})
export default class NoPrebillAlertModal extends Vue {
  batchModuleInstance: BatchModule = getModule(BatchModule, this.$store)
  
  get payersList () {
    return this.$store.state.statement.getNoPrebillItems
  }

  getMonthLabel (monthIndex: number) {
    return MONTHS[monthIndex - 1]
  }

  onConfirm () {
    this.batchModuleInstance.confirmMissingPayerCharges(this.$props.batchId)
    this.$emit('process')
  }
}
